<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('restoration')" :class="{'active': section === 'restoration'}">Restaurācijas pamatdati</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
            <div class="menuItem" @click="changeSection('images')" :class="{'active': section === 'images'}">Attēli</div>
<!--            <div class="menuItem" @click="changeSection('documents')" :class="{'active': section === 'documents'}">Saistītie dokumenti</div>-->
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div v-if="section == 'restoration'"class="section">
                    <div class="sectionTitle">Restaurācijas pamatdati</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="event_name">Nosaukums</label>
                                    <input type="text" id="event_name" v-model="event_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="start_date">Sākuma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="start_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="end_date">Beigu datums</label>
                                        <v-date-picker
                                            :popover="{ visibility: 'click' }"
                                            mode="single"
                                            v-model="end_date"
                                            :type="'date'"
                                            :locale="'LV'"
                                            color="teal"
                                            :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                        />
                                    </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="restorer">Restaurātors</label>
                                    <input type="text" id="restorer" v-model="restorer" class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <textarea name="description" id="description" rows="5" v-model="description" class="form-control">{{description}}</textarea>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="section == 'items'"class="section">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions">
                            <items-search-component></items-search-component>
                        </div>
                        <div class="fixedHeight">
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Restaurācijas pase nr.</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td style="width:150px;">
                                    <input type="text" v-model="item.pivot.passport_number" class="form-control">
                                </td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                        ></item-view-component>
                                        <div @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>
                        </div>
                        <hr>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="saveItems()">Saglabāt</button>
                        </div>
                    </div>
                </div>
                <div v-if="section == 'images'"class="section">
                    <div class="sectionTitle">Attēli</div>
                    <div class="sectionContent">
                        <CoolLightBox
                            :items="imageListForLightboxBeforeRestoration"
                            :index="index_before"
                            srcName="src"
                            @close="index_before = null">
                        </CoolLightBox>
                        <CoolLightBox
                            :items="imageListForLightboxInProcess"
                            :index="index_in_process"
                            srcName="src"
                            @close="index_in_process = null">
                        </CoolLightBox>
                        <CoolLightBox
                            :items="imageListForLightboxAfterRestoration"
                            :index="index_after"
                            srcName="src"
                            @close="index_after = null">
                        </CoolLightBox>
                        <div class="subsection">
                            <div class="title">
                                Pirms restaurācijas
                            </div>
                        </div>
                        <div class="gallery" v-if="this.imagesBeforeRestoration.length > 0">
                            <div v-for="(image, imageIndex) in this.imagesBeforeRestoration" :key="image.id" class="galleryItem">
                                <div class="image">
                                    <img @click="index_before = imageIndex" :src="'/restoration/'+image.restoration_id+'/image-show/thumb/'+image.file_name">
                                    <div class="delete" @click="deleteImage(image.id)">
                                        <span class="material-icons">close</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-info">Nav pievienots neviens fotoattēls.</div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Restaurācijas procesā
                            </div>
                        </div>
                        <div class="gallery" v-if="this.imagesInProcess.length > 0">
                            <div v-for="(image, imageIndex) in this.imagesInProcess" :key="image.id" class="galleryItem">
                                <div class="image">
                                    <img @click="index_in_process = imageIndex" :src="'/restoration/'+image.restoration_id+'/image-show/thumb/'+image.file_name">
                                    <div class="delete" @click="deleteImage(image.id)">
                                        <span class="material-icons">close</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-info">Nav pievienots neviens fotoattēls.</div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Pēc restaurācijas
                            </div>
                        </div>
                        <div class="gallery" v-if="this.imagesAfterRestoration.length > 0">
                            <div v-for="(image, imageIndex) in this.imagesAfterRestoration" :key="image.id" class="galleryItem">
                                <div class="image">
                                    <img @click="index_after = imageIndex" :src="'/restoration/'+image.restoration_id+'/image-show/thumb/'+image.file_name">
                                    <div class="delete" @click="deleteImage(image.id)">
                                        <span class="material-icons">close</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-info">Nav pievienots neviens fotoattēls.</div>
                        </div>
                    </div>
                </div>
                <div v-if="section == 'documents'"class="section">
                    <div class="sectionTitle">Dokumenti</div>
                    <div class="sectionContent">

                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="section" v-if="section == 'images'">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="image_type">Izvēlies attēla veidu</label>
                                    <select name="image_type" id="image_type" v-model="image_type" class="form-control">
                                        <option value="image_before">Pirms restaurācijas</option>
                                        <option value="image_in_process">Restaurācijas procesā</option>
                                        <option value="image_after">Pēc restaurācijas</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <dropzone ref="images"  @vdropzone-sending="dropzoneImageSending" @vdropzone-success="dropzoneImageSuccess" @vdropzone-error="dropzoneImageError" :useCustomSlot=true :options="{headers:headers,parallelUploads: 1, previewTemplate: template(),url: '/restoration/'+this.id+'/image-upload',maxFilesize: 10, acceptedFiles: ' .jpeg,.jpg,.png,.gif ', thumbnailWidth: 20}" id="file">
                                        <div class="dropzone-custom-content">
                                            <h3 class="dropzone-custom-title">Pievienot attēlus</h3>
                                        </div>
                                    </dropzone>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="section" v-if="section == 'items'">
                    <div class="sectionTitle">Pievienošana</div>
                    <div class="sectionContent" >
                        <div class="row">
                            <div class="col-12 text-left">
                                <div class="form-group">
                                    <get-from-external-act></get-from-external-act>
                                </div>
                                <div class="form-group">
                                    <get-from-internal-act></get-from-internal-act>
                                </div>
                                <div class="form-group">
                                    <researchers-lists></researchers-lists>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.gallery{
    display:flex;
    flex-wrap:wrap;
    .galleryItem{
        padding:10px;
        position: relative;
        width:25%;
        .delete{
            position:absolute;
            top:20px;
            right:20px;
            width:30px;
            height:30px;
            background:rgba(255,255,255,.75);
            cursor: pointer;
            border-radius: 100%;
            display:flex;
            align-items: center;
            justify-content: center;

        }
    }
    .image{
        img{
            width:100% !important;
            max-width:100%;
            height:auto;
        }
    }
}
.fixedHeight
{
    max-height:70vh;
    overflow:auto;
    position:relative;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import ItemViewComponent from "../items/ItemViewComponent";
import Dropzone from "vue2-dropzone";
export default{
    components: {ItemViewComponent, Dropzone},
    props:['restoration','current_user','user'],
    mounted()
    {
        this.items=this.$props.restoration.items;
        this.images=this.$props.restoration.images;
        this.id = this.$props.restoration.id;
        this.event_name = this.$props.restoration.event_name;
        this.start_date = moment(this.$props.restoration.start_date, moment.ISO_8601)._d;
        this.end_date = moment(this.$props.restoration.end_date, moment.ISO_8601)._d;
        this.restorer = this.$props.restoration.restorer
        this.description = this.$props.restoration.description


        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            //Should save items data before adding
            that.saveItems(false);
            axios.post('/restorations/add-item-to-list/'+that.id,
                {
                    item_id: item_id
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.restoration.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });
        EventBus.$on('add_items_to_list',items_ids =>{
            //Should save items data before adding
            that.saveItems(false);
            axios.post('/restorations/add-items-to-list/'+that.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.restoration.items;
                    that.$toast.open(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        deleteImage(image_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst attēlu?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    axios.post('/restoration/' + this.id + '/image-delete/' + image_id)
                        .then(response => {
                            if (response.data.status == 'ok') {
                                that.images = response.data.images;
                                this.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                this.$toast.error(response.data.message);
                            }
                        });
                }
            });
        },
        dropzoneImageSuccess(file, response)
        {
            var that = this;
            that.images = response.images;
            this.$toast.open("Attēls - "+response.image.file+" - veiksmīgi augšupielādēts.");
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
            this.errors = [];

        },
        dropzoneImageError(file, message, xhr)
        {

            this.$toast.open({
                message: "Attēla augšupielāde neizdevās."+message,
                position: "top-right",
                type:"error",
            });
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
        },
        dropzoneImageSending(file, xhr, formData)
        {
            formData.append('image_type', this.image_type);
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
            }
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
        normalFloat(number)
        {
            if(number != null)
            {
                return parseFloat(number).toFixed(2);
            }
            return null;

        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        //Should save informaction before removing
                        that.saveItems(false);
                        axios.post('/restorations/remove-item-from-list/' + that.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.restoration.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.error(response.data.message);
                            }
                        });
                    }});
        },


        saveItems(showStatus = true)
        {
            var that = this;
            axios.post('/restorations/save-items/'+that.id,{
                items: that.items,
            }).then(response =>{
                if(response.data.status === 'ok' && showStatus == true)
                {
                    that.$toast.open(response.data.message);
                }
                if(response.data.status === 'error' && showStatus == true)
                {
                    that.$toast.error(response.data.message);
                }
            });
        },
      save()
      {
          var that = this;
          var data = {
              event_name: this.event_name,
              start_date: this.start_date,
              end_date: this.end_date,
              restorer: this.restorer,
              description: this.description,
          }
          axios.post('/restorations/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      },
        changeSection(section)
        {
            this.section = section;
        },
    },
    data()
    {
        return{
            id:"",
            event_name:"",
            start_date:"",
            end_date:"",
            restorer:"",
            description:"",
            items:[],
            images:[],
            index_before:null,
            index_in_process:null,
            index_after:null,

            section:"restoration",
            loading:false,
            image_type:"image_before",

            headers: {
                "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
            },
            template: function () {
                return `<div class="dz-preview dz-file-preview">
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>

                    </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>

                </div>
            `;
            },

        }
    },
    computed:{
        imagesBeforeRestoration()
        {
            var that = this;
            if(that.images)
            {
                return that.images.filter(function(image) {
                    if (image.type == 'image_before') {
                        return true;
                    }
                })
            }
        },
        imagesInProcess()
        {
            var that = this;
            if(that.images)
            {
                return that.images.filter(function(image) {
                    if (image.type == 'image_in_process') {
                        return true;
                    }
                })
            }
        },
        imagesAfterRestoration()
        {
            var that = this;
            if(that.images)
            {
                return that.images.filter(function(image) {
                    if (image.type == 'image_after') {
                        return true;
                    }
                })
            }
        },



        imageListForLightboxBeforeRestoration()
        {
            if(this.imagesBeforeRestoration)
            {
                return this.imagesBeforeRestoration.map(function(image)
                {
                    return {
                        src:'/restoration/'+image.restoration_id+'/image-show/large/'+image.file_name,
                        description:image.filename
                    }
                });
            }
            else
            {
                return [];
            }
        },

        imageListForLightboxInProcess()
        {
            if(this.imagesInProcess)
            {
                return this.imagesInProcess.map(function(image)
                {
                    return {
                        src:'/restoration/'+image.restoration_id+'/image-show/large/'+image.file_name,
                        description:image.filename
                    }
                });
            }
            else
            {
                return [];
            }
        },
        imageListForLightboxAfterRestoration()
        {
            if(this.imagesAfterRestoration)
            {
                return this.imagesAfterRestoration.map(function(image)
                {
                    return {
                        src:'/restoration/'+image.restoration_id+'/image-show/large/'+image.file_name,
                        description:image.filename
                    }
                });
            }
            else
            {
                return [];
            }
        },

        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
